import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import DefineKeysForm from './form'

const DefineKeysDialog = React.forwardRef(function DefineKeysDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (source) => setDialogState({ open: true, processing: false, source })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Define Keys'
      open={dialogState.open}
      onClose={close}
      size='full'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<DefineKeysForm source={dialogState.source} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

DefineKeysDialog.propTypes = {
  onComplete: PropTypes.func
}

DefineKeysDialog.defaultProps = {
  onComplete: () => {}
}

export default DefineKeysDialog
